import Swal from 'sweetalert2';
import './Alerta.css';

/**
 * Componente de alerta completamente reutilizable con logo opcional
 * @param {Object} props - Propiedades de la alerta
 * @param {string} props.type - Tipo de alerta (success, error, warning, info, question)
 * @param {string} props.title - Título de la alerta
 * @param {string|ReactNode} props.content - Contenido principal
 * @param {Object} props.options - Opciones adicionales de SweetAlert2
 * @param {function} props.onConfirm - Función al confirmar
 * @param {function} props.onCancel - Función al cancelar
 * @param {string} props.logoUrl - URL del logo (opcional)
 * @param {string} props.logoAlt - Texto alternativo del logo (opcional)
 * @param {string} props.logoClass - Clases CSS adicionales para el logo (opcional)
 */


const Alerta = ({
  type = 'info',
  title = '',
  content = '',
  options = {},
  onConfirm = () => {},
  onCancel = () => {},
  logoUrl = null,
  logoAlt = 'Logo',
  logoClass = ''
}) => {
  // Configuración base que no afecta otros componentes
  const baseConfig = {
    allowOutsideClick: false,
    allowEscapeKey: false,
    scrollbarPadding: false,
    backdrop: 'rgba(0,0,0,0.7)'
  };

  const buildContent = () => {
    let fullContent = content;
    
    if (logoUrl) {
      fullContent = `
        <div class="custom-swal-logo-container">
          <img src="${logoUrl}" alt="${logoAlt}" class="custom-swal-logo ${logoClass}" />
        </div>
        ${content}
      `;
    }
    
    return `<div class="custom-swal-container">${fullContent}</div>`;
  };

  Swal.fire({
    icon: type,
    title: `<span class="custom-swal-title">${title}</span>`,
    html: buildContent(),
    background: '#273b47',
    color: '#f3f8fb',
    showCancelButton: !!onCancel,
    confirmButtonColor: '#98ca3f',
    cancelButtonColor: '#6c757d',
    customClass: {
      popup: 'custom-swal-popup',
      title: 'custom-swal-title',
      htmlContainer: 'custom-swal-html',
      confirmButton: 'custom-swal-confirm',
      cancelButton: 'custom-swal-cancel',
      ...options.customClass
    },
    ...baseConfig, // Config base aplicada primero
    ...options     // Opciones específicas sobrescriben la base
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm(result);
    } else if (result.isDismissed) {
      onCancel();
    }
  });

  return null;
};

export default Alerta;


